import React, { Component } from 'react'

function imageFile(dataTransfer) {
  const { files } = dataTransfer
  if (files.length > 0) {
    if (files[0].type.startsWith('image/')) {
      return files[0]
    }
  }
  return undefined
}

function containsFiles(dataTransfer) {
  const { types } = dataTransfer
  return types.length === 1 && types[0] === 'Files'
}

class ImageDropArea extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dragOver: 0,
    }
  }

  incrementDragOver() {
    this.setState({ dragOver: this.state.dragOver + 1 })
  }

  decrementDragOver() {
    this.setState({ dragOver: this.state.dragOver - 1 })
  }

  resetDragOver() {
    this.setState({ dragOver: 0 })
  }

  onDragEnter(event) {
    event.preventDefault()
    this.incrementDragOver()
  }

  onDragOver = (event) => {
    event.preventDefault()
    if (this.props.onDrop !== undefined && containsFiles(event.dataTransfer)) {
      event.dataTransfer.dropEffect = 'copy'
    }
  }

  onDrop = (event) => {
    event.preventDefault()
    if (this.props.onDrop !== undefined && containsFiles(event.dataTransfer)) {
      const image = imageFile(event.dataTransfer)
      if (image !== undefined) {
        this.props.onDrop(image)
      }
    }
    this.resetDragOver()
  }

  onDragLeave = (event) => {
    event.preventDefault()
    this.decrementDragOver()
  }

  render() {
    const { children, onDrop } = this.props
    return (
      <div
        className="imageDropArea"
        onDragEnter={this.onDragEnter}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}
        onDragLeave={this.onDragLeave}
        dragover={onDrop ? (this.state.dragOver ? 'yes' : 'no') : 'disabled'}
      >
        {children}
      </div>
    )
  }
}

export default ImageDropArea
